import React from 'react';
import AppLayout from '@/components/layout/AppLayout';
import AttachmentList from '@/components/attachments/AttachmentList';
import AttachmentAnalytics from '@/components/dashboard/AttachmentAnalytics';
import AttachmentInsights from '@/components/dashboard/AttachmentInsights';
import DownloadManager from '@/components/attachments/DownloadManager';
import { useAttachments } from '@/context/AttachmentContext';
import { Loader2, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

const Dashboard = () => {
  const { fetchAttachments, isLoading } = useAttachments();
  
  return (
    <AppLayout>
      <div className="mb-6 sm:mb-8">
        <div className="flex flex-col items-center text-center mb-4 sm:mb-6">
          <div className="mb-4">
            <h1 className="text-2xl sm:text-3xl font-medium bg-gradient-to-r from-primary to-primary/70 bg-clip-text text-transparent animate-fade-in">Your Attachments</h1>
            <p className="text-muted-foreground mt-1">
              Manage all your email attachments in one place
            </p>
          </div>
          
          <Button
            variant="outline"
            className="shadow-sm hover:shadow-md transition-all"
            onClick={() => fetchAttachments()}
            disabled={isLoading}
          >
            {isLoading ? (
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            ) : (
              <RefreshCw className="mr-2 h-4 w-4" />
            )}
            Refresh
          </Button>
        </div>
      </div>
      
      {/* Attachment Insights - Glassmorphism */}
      <div className="mb-8 rounded-lg border bg-white/30 backdrop-blur-lg border-white/40 dark:bg-black/20 dark:border-white/10 transition-all duration-300 hover:shadow-lg">
        <AttachmentInsights />
      </div>
      
      {/* Analytics section - Glassmorphism */}
      <div className="mb-8 rounded-lg border bg-white/30 backdrop-blur-lg border-white/40 dark:bg-black/20 dark:border-white/10 transition-all duration-300 hover:shadow-lg">
        <AttachmentAnalytics />
      </div>
      
      {/* Attachment List - Glassmorphism */}
      <div className="rounded-lg border bg-white/30 backdrop-blur-lg border-white/40 dark:bg-black/20 dark:border-white/10 transition-all duration-300 hover:shadow-lg p-4 sm:p-6">
        <AttachmentList />
      </div>
      <DownloadManager />
    </AppLayout>
  );
};

export default Dashboard;
